import { EntityRepository, Repository } from "typeorm";
import { ConsumedItemsForSoReq } from "../dto/get-consumed-items.dto";
import { StoreConsumption } from "../entity/store-consumption.entity";

@EntityRepository(StoreConsumption)
export class StoreConsumptionRepository extends Repository<StoreConsumption> {

    
}